import { useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
//components
import Panel from "../../../components/panel/panel";
import ExportTable from "../../../components/button/ExportButton";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//services
import { postReverseInstallment } from "../../../services/Report/postReverseInstallment";
import FiltersReversalOfInstallments from "../../Financial/ReversalReport/FiltersReversalOfInstallments";
//utils
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
import { getReportReverseInstallment } from "../../../services/Report/getReportReverseInstallment";

export default function ReversalOfInstallments() {
  const [lastData, setLastData] = useState();
  const [table, setTable] = useState();
  const [visible, setVisible] = useState(false);
  const [itemsSelected, setItemsSelected] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const items = [
    {
      template: () => (
        <Link
          to={"/reports/reversalOfInstallments"}
          className="p-breadcrumb-link"
        >
          Estorno de Parcelas
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const columns = [
    { field: "id", header: `Código` },
    { field: "sequence_number", header: `N° Parcela` },
    {
      field: "client",
      header: `Cliente`,
    },
    {
      field: "desc",
      header: "Descrição",
    },
    {
      field: "enterprise",
      header: "Empreendimento",
    },
    {
      field: "status",
      header: "Situação",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "A Vencer";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "todos";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "local",
      header: "Q/L",
    },
    {
      field: "due_date",
      header: "Data de Vencimento",
      body: (rowData) => rowData.due_date && formatDate(rowData.due_date),
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => rowData.value && formatCurrency(rowData.value),
    },
    {
      field: "payment_date",
      header: "Data Recebimento",
      body: (rowData) =>
        rowData.payment_date && formatDate(rowData.payment_date),
    },
    {
      field: "discount",
      header: "Desconto",
    },
    {
      field: "fine",
      header: "Acréscimo",
    },
    {
      field: "payment_method",
      header: "Forma de Pagamento",
    },
    {
      field: "released_by",
      header: "Lançado por",
    },
    {
      field: "completed_by",
      header: "Baixado por",
    },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onSelectionChange = (event) => {
    const value = event.value;
    setItemsSelected(value);
  };

  const acceptInstallments = async (parcels) => {
    const notification = toast.loading("Por favor aguarde...");
    const data = {};
    data.installments = [];
    parcels.map((p) => data.installments.push(p.id));
    try {
      await postReverseInstallment(data);
      const response = await getReportReverseInstallment(lastData);
      response.map((i) => (i.local = `${i.block}/${i.land}`));
      setTable(response);
      toast.update(notification, {
        render: "Ação efetuada com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setItemsSelected([]);
    } catch (e) {
      toast.error(`Não Possível Desfazer o Estorno!`);
    }
  };

  const handleInstallments = () => {
    confirmDialog({
      message: "Deseja desfazer o estorno?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => acceptInstallments(itemsSelected),
    });
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="col-md-4">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-md-8">
          <div className="row justify-content-end pb-3">
            <div className="col-md-4">
              <Button
                rounded
                icon="fa fa-undo"
                severity="warning"
                disabled={itemsSelected.length === 0}
                label="Desfazer Estorno"
                onClick={() => handleInstallments()}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          </div>
        </div>
        <Panel title="Estorno de Parcelas">
          <FiltersReversalOfInstallments
            setLastData={setLastData}
            setTable={setTable}
            setVisible={setVisible}
          />
        </Panel>

        {visible && (
          <Panel title="Relatório de Recebimentos no Período" mainCss="mt-4">
            <ExportTable
              tableData={table}
              exportColumns={exportColumns}
              tabelaKey="Relatório de Recebimentos no Período"
              globalFilterValue={globalFilterValue}
              onGlobalFilterChange={onGlobalFilterChange}
            />
            <DataTable
              rows={25}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="multiple"
              rowsPerPageOptions={[5, 25, 100]}
              value={table}
              selection={itemsSelected}
              onSelectionChange={onSelectionChange}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              <Column key="selected" field="select" selectionMode="multiple" />
              {columns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  body={col.body}
                />
              ))}
            </DataTable>
          </Panel>
        )}
      </div>
    </>
  );
}
